export const selectAboutUs = (state) => state.general.aboutUs;

export const selectFsboContacts = (state) => state.general.fsboContacts;
export const selectCarousel = (state) => state.general.carousel;
